import { AnyAction } from 'redux';
import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';
import {
    fetchOrganizationCustomerAddresses,
    fetchOrganizationCustomerAppliances,
    fetchOrganizationCustomerData,
    fetchOrganizationCustomerEnables,
    fetchOrganizationCustomerLandingpages,
    fetchOrganizationCustomerOrders,
    fetchOrganizationCustomerReferralPartner,
    fetchOrganizationCustomers,
    fetchOrganizationFavorites,
    fetchOrganizationLicensors,
    fetchOrganizationOfficeProfis,
    fetchOrganizationOverview,
    fetchOrganizationPlacements,
    fetchOrganizationSisPartners,
    fetchOrganizationStatistic,
    fetchRegisteredEvents,
    fetchVideoList,
} from 'src/api/organization';
import {
    FETCH_ORGANIZATION_CUSTOMERS,
    FETCH_ORGANIZATION_CUSTOMER_ADDRESSES,
    FETCH_ORGANIZATION_CUSTOMER_APPLIANCES,
    FETCH_ORGANIZATION_CUSTOMER_DATA,
    FETCH_ORGANIZATION_CUSTOMER_ENABLES,
    FETCH_ORGANIZATION_CUSTOMER_LANDINGPAGES,
    FETCH_ORGANIZATION_CUSTOMER_ORDERS,
    FETCH_ORGANIZATION_CUSTOMER_REFERRAL_PARTNER,
    FETCH_ORGANIZATION_FAVORITES,
    FETCH_ORGANIZATION_LICENSORS,
    FETCH_ORGANIZATION_OFFICE_PROFIS,
    FETCH_ORGANIZATION_OVERVIEW,
    FETCH_ORGANIZATION_PLACEMENTS,
    FETCH_ORGANIZATION_SIS_PARTNERS,
    FETCH_ORGANIZATION_STATISTIC,
    FETCH_REGISTERED_EVENTS,
    FETCH_VIDEO_LIST,
    requestOrganizationCustomerAddresses,
    requestOrganizationCustomerAddressesFailure,
    requestOrganizationCustomerAddressesSuccess,
    requestOrganizationCustomerAppliances,
    requestOrganizationCustomerAppliancesFailure,
    requestOrganizationCustomerAppliancesSuccess,
    requestOrganizationCustomerData,
    requestOrganizationCustomerDataFailure,
    requestOrganizationCustomerDataSuccess,
    requestOrganizationCustomerEnables,
    requestOrganizationCustomerEnablesFailure,
    requestOrganizationCustomerEnablesSuccess,
    requestOrganizationCustomerLandingpages,
    requestOrganizationCustomerLandingpagesFailure,
    requestOrganizationCustomerLandingpagesSuccess,
    requestOrganizationCustomerOrders,
    requestOrganizationCustomerOrdersFailure,
    requestOrganizationCustomerOrdersSuccess,
    requestOrganizationCustomerReferralPartner,
    requestOrganizationCustomerReferralPartnerFailure,
    requestOrganizationCustomerReferralPartnerSuccess,
    requestOrganizationCustomers,
    requestOrganizationCustomersFailure,
    requestOrganizationCustomersSuccess,
    requestOrganizationFavorites,
    requestOrganizationFavoritesFailure,
    requestOrganizationFavoritesSuccess,
    requestOrganizationLicensors,
    requestOrganizationLicensorsFailure,
    requestOrganizationLicensorsSuccess,
    requestOrganizationOfficeProfis,
    requestOrganizationOfficeProfisFailure,
    requestOrganizationOfficeProfisSuccess,
    requestOrganizationOverview,
    requestOrganizationOverviewFailure,
    requestOrganizationOverviewSuccess,
    requestOrganizationPlacements,
    requestOrganizationPlacementsFailure,
    requestOrganizationPlacementsSuccess,
    requestOrganizationSisPartners,
    requestOrganizationSisPartnersFailure,
    requestOrganizationSisPartnersSuccess,
    requestOrganizationStatistic,
    requestOrganizationStatisticFailure,
    requestOrganizationStatisticSuccess,
    requestRegisteredEvents,
    requestRegisteredEventsFailure,
    requestRegisteredEventsSuccess,
    requestVideoList,
    requestVideoListFailure,
    requestVideoListSuccess,
} from './actions';

/* Organization statsitic */
function* fetchOrganizationStatisticSaga(action: AnyAction): SagaIterator {
    yield put(requestOrganizationStatistic());

    const { error, response } = yield call(fetchOrganizationStatistic, action.id);

    if (error) yield put(requestOrganizationStatisticFailure(error));
    else yield put(requestOrganizationStatisticSuccess(response));
}

export function* generateFetchOrganizationStatisticWatcher() {
    yield takeLatest(FETCH_ORGANIZATION_STATISTIC, fetchOrganizationStatisticSaga);
}

/* Organization Overview */
function* fetchOrganizationOverviewSaga(action: AnyAction): SagaIterator {
    yield put(requestOrganizationOverview());

    const { error, response } = yield call(fetchOrganizationOverview, action.id, action.pageable);

    if (error) yield put(requestOrganizationOverviewFailure(error));
    else yield put(requestOrganizationOverviewSuccess(response));
}

export function* generateFetchOrganizationOverviewWatcher() {
    yield takeLatest(FETCH_ORGANIZATION_OVERVIEW, fetchOrganizationOverviewSaga);
}

/* Fetch Registered Events */
function* fetchRegisteredEventsSaga(action: AnyAction): SagaIterator {
    yield put(requestRegisteredEvents());

    const { error, response } = yield call(fetchRegisteredEvents, action.id, action.partnerId);

    if (error) yield put(requestRegisteredEventsFailure(error));
    else yield put(requestRegisteredEventsSuccess(response));
}

export function* generatefetchRegisteredEventsWatcher() {
    yield takeLatest(FETCH_REGISTERED_EVENTS, fetchRegisteredEventsSaga);
}

/* Fetch Organization Customer Appliances */
function* fetchOrganizationCustomerAppliancesSaga(action: AnyAction): SagaIterator {
    yield put(requestOrganizationCustomerAppliances());

    const { error, response } = yield call(fetchOrganizationCustomerAppliances, action.sourceId, action.targetId);

    if (error) yield put(requestOrganizationCustomerAppliancesFailure(error));
    else yield put(requestOrganizationCustomerAppliancesSuccess(response));
}

export function* generateFetchOrganizationCustomerAppliancesWatcher() {
    yield takeLatest(FETCH_ORGANIZATION_CUSTOMER_APPLIANCES, fetchOrganizationCustomerAppliancesSaga);
}

/* Fetch Video List */
function* fetchVideoListSaga(action: AnyAction): SagaIterator {
    yield put(requestVideoList());

    const { error, response } = yield call(fetchVideoList, action.id, action.partnerId);

    if (error) yield put(requestVideoListFailure(error));
    else yield put(requestVideoListSuccess(response));
}

export function* generatefetchVideoListWatcher() {
    yield takeLatest(FETCH_VIDEO_LIST, fetchVideoListSaga);
}

/* Fetch Organization Customer Orders */
function* fetchOrganizationCustomerOrdersSaga(action: AnyAction): SagaIterator {
    yield put(requestOrganizationCustomerOrders());

    const { error, response } = yield call(
        fetchOrganizationCustomerOrders,
        action.id,
        action.partnerId,
        action.pageable
    );

    if (error) yield put(requestOrganizationCustomerOrdersFailure(error));
    else yield put(requestOrganizationCustomerOrdersSuccess(response));
}

export function* generateFetchOrganizationCustomerOrdersWatcher() {
    yield takeLatest(FETCH_ORGANIZATION_CUSTOMER_ORDERS, fetchOrganizationCustomerOrdersSaga);
}

/* Fetch Organization Customer Data */
function* fetchOrganizationCustomerDataSaga(action: AnyAction): SagaIterator {
    yield put(requestOrganizationCustomerData());

    const { error, response } = yield call(fetchOrganizationCustomerData, action.sourceId, action.targetId);

    if (error) yield put(requestOrganizationCustomerDataFailure(error));
    else yield put(requestOrganizationCustomerDataSuccess(response));
}

export function* generateFetchOrganizationCustomerDataWatcher() {
    yield takeLatest(FETCH_ORGANIZATION_CUSTOMER_DATA, fetchOrganizationCustomerDataSaga);
}

/* Fetch Organization Customer Addresses */
function* fetchOrganizationCustomerAddressesSaga(action: AnyAction): SagaIterator {
    yield put(requestOrganizationCustomerAddresses());

    const { error, response } = yield call(fetchOrganizationCustomerAddresses, action.sourceId, action.targetId);

    if (error) yield put(requestOrganizationCustomerAddressesFailure(error));
    else yield put(requestOrganizationCustomerAddressesSuccess(response));
}

export function* generateFetchOrganizationCustomerAddressesWatcher() {
    yield takeLatest(FETCH_ORGANIZATION_CUSTOMER_ADDRESSES, fetchOrganizationCustomerAddressesSaga);
}

/* Fetch Organization Customer Landingpages */
function* fetchOrganizationCustomerLandingpagesSaga(action: AnyAction): SagaIterator {
    yield put(requestOrganizationCustomerLandingpages());

    const { error, response } = yield call(fetchOrganizationCustomerLandingpages, action.sourceId, action.targetId);

    if (error) yield put(requestOrganizationCustomerLandingpagesFailure(error));
    else yield put(requestOrganizationCustomerLandingpagesSuccess(response));
}

export function* generateFetchOrganizationCustomerLandingpagesWatcher() {
    yield takeLatest(FETCH_ORGANIZATION_CUSTOMER_LANDINGPAGES, fetchOrganizationCustomerLandingpagesSaga);
}

/* Fetch Organization Customer Referral Partner */
function* fetchOrganizationCustomerReferralPartnerSaga(action: AnyAction): SagaIterator {
    yield put(requestOrganizationCustomerReferralPartner());

    const { error, response } = yield call(fetchOrganizationCustomerReferralPartner, action.sourceId, action.targetId);

    if (error) yield put(requestOrganizationCustomerReferralPartnerFailure(error));
    else yield put(requestOrganizationCustomerReferralPartnerSuccess(response));
}

export function* generateFetchOrganizationCustomerReferralPartnerWatcher() {
    yield takeLatest(FETCH_ORGANIZATION_CUSTOMER_REFERRAL_PARTNER, fetchOrganizationCustomerReferralPartnerSaga);
}

/* Fetch Organization Customer Enables */
function* fetchOrganizationCustomerEnablesSaga(action: AnyAction): SagaIterator {
    yield put(requestOrganizationCustomerEnables());

    const { error, response } = yield call(fetchOrganizationCustomerEnables, action.sourceId, action.targetId);

    if (error) yield put(requestOrganizationCustomerEnablesFailure(error));
    else yield put(requestOrganizationCustomerEnablesSuccess(response));
}

export function* generateFetchOrganizationCustomerEnablesWatcher() {
    yield takeLatest(FETCH_ORGANIZATION_CUSTOMER_ENABLES, fetchOrganizationCustomerEnablesSaga);
}

/* Fetch Favorites */
function* fetchOrganizationFavoritesSaga(action: AnyAction): SagaIterator {
    yield put(requestOrganizationFavorites());

    const { error, response } = yield call(fetchOrganizationFavorites, action.id);

    if (error) yield put(requestOrganizationFavoritesFailure(error));
    else yield put(requestOrganizationFavoritesSuccess(response));
}

export function* generateFetchOrganizationFavoritesWatcher() {
    yield takeLatest(FETCH_ORGANIZATION_FAVORITES, fetchOrganizationFavoritesSaga);
}

/* Fetch Organization Customers */
function* fetchOrganizationCustomersSaga(action: AnyAction): SagaIterator {
    yield put(requestOrganizationCustomers());

    const { error, response } = yield call(fetchOrganizationCustomers, action.id, action.pageable);

    if (error) yield put(requestOrganizationCustomersFailure(error));
    else yield put(requestOrganizationCustomersSuccess(response));
}

export function* generateFetchOrganizationCustomersWatcher() {
    yield takeLatest(FETCH_ORGANIZATION_CUSTOMERS, fetchOrganizationCustomersSaga);
}

/* Fetch Organization Sis Partners */
function* fetchOrganizationSisPartnersSaga(action: AnyAction): SagaIterator {
    yield put(requestOrganizationSisPartners());

    const { error, response } = yield call(fetchOrganizationSisPartners, action.id, action.pageable);

    if (error) yield put(requestOrganizationSisPartnersFailure(error));
    else yield put(requestOrganizationSisPartnersSuccess(response));
}

export function* generateFetchOrganizationSisPartnersWatcher() {
    yield takeLatest(FETCH_ORGANIZATION_SIS_PARTNERS, fetchOrganizationSisPartnersSaga);
}

/* Fetch Organization Licensors */
function* fetchOrganizationLicensorsSaga(action: AnyAction): SagaIterator {
    yield put(requestOrganizationLicensors());

    const { error, response } = yield call(fetchOrganizationLicensors, action.id, action.pageable);

    if (error) yield put(requestOrganizationLicensorsFailure(error));
    else yield put(requestOrganizationLicensorsSuccess(response));
}

export function* generateFetchOrganizationLicensorsWatcher() {
    yield takeLatest(FETCH_ORGANIZATION_LICENSORS, fetchOrganizationLicensorsSaga);
}

/* Fetch Organization Placements */
function* fetchOrganizationPlacementsSaga(action: AnyAction): SagaIterator {
    yield put(requestOrganizationPlacements());

    const { error, response } = yield call(fetchOrganizationPlacements, action.id, action.pageable);

    if (error) yield put(requestOrganizationPlacementsFailure(error));
    else yield put(requestOrganizationPlacementsSuccess(response));
}

export function* generateFetchOrganizationPlacementsWatcher() {
    yield takeLatest(FETCH_ORGANIZATION_PLACEMENTS, fetchOrganizationPlacementsSaga);
}

/* Fetch Organization Office Profis */
function* fetchOrganizationOfficeProfisSaga(action: AnyAction): SagaIterator {
    yield put(requestOrganizationOfficeProfis());

    const { error, response } = yield call(fetchOrganizationOfficeProfis, action.id, action.pageable);

    if (error) yield put(requestOrganizationOfficeProfisFailure(error));
    else yield put(requestOrganizationOfficeProfisSuccess(response));
}

export function* generateFetchOrganizationOfficeProfisWatcher() {
    yield takeLatest(FETCH_ORGANIZATION_OFFICE_PROFIS, fetchOrganizationOfficeProfisSaga);
}
